<div class="general-container appear">
  <fun-spinner *ngIf="loading"></fun-spinner>
    <div *ngIf="!loading && benefitsByMonth && benefitsByMonth.length > 0"
      class="flex gap-x-6 items-center justify-end py-12 my-16">
      <fun-new-button size="s" (eventClick)="changeMode('list')" icon="coin-stack" iconPosition="right" [buttonType]="mode === 'list' ? 'primaryDark' : 'secondaryDark'" title="{{ 'CALENDAR.LIST' | translate }}"></fun-new-button>
      <fun-new-button size="s" (eventClick)="changeMode('calendar')" icon="calendar" iconPosition="right" [buttonType]="mode === 'calendar' ? 'primaryDark' : 'secondaryDark'" title="{{ 'CALENDAR.CALENDAR' | translate }}"></fun-new-button>
    </div>
    <div *ngIf="mode === 'calendar' && !loading" class="py-72">
      <fun-calendar-pay-timetable [calendarBenefits]="benefitsByMonth"></fun-calendar-pay-timetable>
    </div>
  <div *ngIf="!loading && benefitsByMonth && benefitsByMonth.length > 0" class="content-container">
    <div *ngIf="benefitsByMonth && !loading && mode === 'list'" class="content-calendar">
        <ng-container *ngFor="let monthWithBenefits of benefitsByMonth;let indice=index">
            <app-calendar-pay-month [indice]="indice + 1" [monthWithBenefits]="monthWithBenefits"></app-calendar-pay-month>
        </ng-container>
    </div>
  </div>
  <div *ngIf="!loading && (!benefitsByMonth || benefitsByMonth.length === 0) && mode === 'list'"
  class="mt-[88px] flex flex-col gap-12 items-center justify-center w-full md:max-w-[720px] p-32 my-16 mx-auto">
    <!-- <img src="../../assets/images/illustrations/notifications.svg" alt="notification"> -->
    <fun-icon [name]="'coin-stack'" [style]="'w-72 h-72 stroke-[2px] stroke-orange-100'"></fun-icon>
    <p class="font-sans text-l text-eggplant-70">{{ 'PAYMENT_CALENDAR.TXT' | translate }}</p>
  </div>
</div>